import React from "react";
import Helper from "./Helper";

export const DataHeroPage = () => {
  return (
    <div className="w-full">
        <Helper />
    </div>
  );
};
